// extracted by mini-css-extract-plugin
export default {"container":"styles_container__mGG8+","container__footer":"styles_container__footer__vITRu","save":"styles_save__qoDxP"};